"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allPropertiesUndefined = exports.matches = exports.valueEquality = exports.equals = exports.copy = exports._ = void 0;
// _ matches any item in value checks (see dispatch.ts for more application)
exports._ = {};
function copy(data) {
    if (typeof data !== 'object' || data === null) {
        return data;
    }
    if (Array.isArray(data)) {
        var array = data;
        return array.map(function (item) { return copy(item); });
    }
    var keys = Object.keys(data);
    var result = {};
    var anyData = data;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var valueForKey = anyData[key];
        result[key] = copy(valueForKey);
    }
    return result;
}
exports.copy = copy;
// Partially from http://stackoverflow.com/a/6713782
function equals(x, y) {
    if (x === exports._) {
        return true;
    }
    if (y === exports._) {
        return true;
    }
    var eqr = primitiveValueEquality(x, y);
    if (eqr === EqualityResult.Equal) {
        return true;
    }
    if (eqr === EqualityResult.Unequal) {
        return false;
    }
    if (typeof x !== 'object' || typeof y !== 'object') {
        return false;
    }
    if (x.constructor !== y.constructor) {
        return false;
    }
    for (var p in x) {
        if (!x.hasOwnProperty(p)) {
            continue;
        }
        if (!y.hasOwnProperty(p)) {
            return false;
        }
        var subEqr = primitiveValueEquality(x[p], y[p]);
        if (subEqr === EqualityResult.Equal) {
            continue;
        }
        if (subEqr === EqualityResult.Unequal) {
            return false;
        }
        if (typeof x[p] !== 'object') {
            return false;
        }
        if (!equals(x[p], y[p])) {
            return false;
        }
    }
    for (var p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
            return false;
        }
    }
    return true;
}
exports.equals = equals;
exports.valueEquality = equals;
// Does value equality, but only one-way, so it will return true if y has all of
// x's properties, but y can also have additional properties.
function matches(x, y) {
    if (x === exports._) {
        return true;
    }
    if (x === y) {
        return true;
    }
    if (x === null) {
        return y === null;
    }
    if (isReallyNaN(x)) {
        return isReallyNaN(y);
    }
    if (typeof x !== 'object' || typeof y !== 'object') {
        return false;
    }
    for (var p in x) {
        if (!x.hasOwnProperty(p)) {
            continue;
        }
        var subEqr = primitiveValueEquality(x[p], y[p]);
        if (subEqr === EqualityResult.Equal) {
            continue;
        }
        if (subEqr === EqualityResult.Unequal) {
            return false;
        }
        if (typeof x[p] !== 'object') {
            return false;
        }
        if (!matches(x[p], y[p])) {
            return false;
        }
    }
    return true;
}
exports.matches = matches;
function allPropertiesUndefined(o) {
    var keys = Object.keys(o);
    if (keys.length === 0) {
        return true;
    }
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var k = keys_2[_i];
        if (o[k] !== undefined) {
            return false;
        }
    }
    return true;
}
exports.allPropertiesUndefined = allPropertiesUndefined;
var EqualityResult;
(function (EqualityResult) {
    EqualityResult[EqualityResult["Equal"] = 1] = "Equal";
    EqualityResult[EqualityResult["Unequal"] = 2] = "Unequal";
    EqualityResult[EqualityResult["Unknown"] = 3] = "Unknown";
})(EqualityResult || (EqualityResult = {}));
function primitiveValueEquality(x, y) {
    if (x === y) {
        return EqualityResult.Equal;
    }
    if (x === null) {
        return (y === null) ? EqualityResult.Equal : EqualityResult.Unequal;
    }
    if (y === null) {
        return (x === null) ? EqualityResult.Equal : EqualityResult.Unequal;
    }
    if (isReallyNaN(x)) {
        return isReallyNaN(y) ? EqualityResult.Equal : EqualityResult.Unequal;
    }
    return EqualityResult.Unknown;
}
// isNaN(undefined) === true, which is why we are checking for typeof === 'number' here
// note: also, isNaN({x: 3}) === true, and isNaN([2]) === true... wtf
function isReallyNaN(x) {
    return isNaN(x) && typeof x === 'number';
}
//# sourceMappingURL=general.js.map